'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = indexById;
function indexById(arr, id) {
    var attrName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

    if (arr == null) {
        return null;
    }
    var leng = arr.length;
    for (var a = 0; a < leng; a++) {
        if (arr[a][attrName] == id) {
            return a;
        }
    }
    return null;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvaW5kZXhCeUlkLmpzeCJdLCJuYW1lcyI6WyJpbmRleEJ5SWQiLCJhcnIiLCJpZCIsImF0dHJOYW1lIiwibGVuZyIsImxlbmd0aCIsImEiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUF3QkEsUztBQUFULFNBQVNBLFNBQVQsQ0FBbUJDLEdBQW5CLEVBQXdCQyxFQUF4QixFQUE2QztBQUFBLFFBQWpCQyxRQUFpQix1RUFBTixJQUFNOztBQUN4RCxRQUFJRixPQUFPLElBQVgsRUFBaUI7QUFDYixlQUFPLElBQVA7QUFDSDtBQUNELFFBQU1HLE9BQU9ILElBQUlJLE1BQWpCO0FBQ0EsU0FBSyxJQUFJQyxJQUFJLENBQWIsRUFBZ0JBLElBQUlGLElBQXBCLEVBQTBCRSxHQUExQixFQUErQjtBQUMzQixZQUFJTCxJQUFJSyxDQUFKLEVBQU9ILFFBQVAsS0FBb0JELEVBQXhCLEVBQTRCO0FBQ3hCLG1CQUFPSSxDQUFQO0FBQ0g7QUFDSjtBQUNELFdBQU8sSUFBUDtBQUNIIiwiZmlsZSI6ImluZGV4QnlJZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGluZGV4QnlJZChhcnIsIGlkLCBhdHRyTmFtZSA9ICdpZCcpIHtcbiAgICBpZiAoYXJyID09IG51bGwpIHtcbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuICAgIGNvbnN0IGxlbmcgPSBhcnIubGVuZ3RoO1xuICAgIGZvciAobGV0IGEgPSAwOyBhIDwgbGVuZzsgYSsrKSB7XG4gICAgICAgIGlmIChhcnJbYV1bYXR0ck5hbWVdID09IGlkKSB7XG4gICAgICAgICAgICByZXR1cm4gYTtcbiAgICAgICAgfVxuICAgIH1cbiAgICByZXR1cm4gbnVsbDtcbn1cbiJdfQ==